import { createContext, useContext } from "react";

/**
 * The element inside the order summary where the step's primary action lands on
 * desktop, so checkout puts its button under the total exactly as the cart does.
 *
 * It is a context rather than a prop because the summary and the step are
 * siblings under CheckoutPage: the page owns the summary, the step owns the
 * button and its state. Handing the button's *destination* down, rather than
 * lifting the button's state up, leaves every handler where it was.
 *
 * `null` until the summary has mounted (or when it failed to render), in which
 * case CheckoutActionBar keeps the action inline in the form column.
 */
export const CheckoutActionSlotContext = createContext<HTMLElement | null>(
  null
);

export function useCheckoutActionSlot(): HTMLElement | null {
  return useContext(CheckoutActionSlotContext);
}
